import React from "react";
import HeaderStatic from "@pwa/Header/HeaderStatic";
import ListPartial from "./Partials/List";

const InsightMobile: React.FC<any> = ({ insightList }) => {
  const { data } = insightList;
  const categoryLabel = data[0]?.category || '';

  return (
    <>
      <HeaderStatic title={categoryLabel} withSearchIcon backUrl={"/insight"} />
      <ListPartial insightList={insightList} />
    </>
  );
};

export default InsightMobile;
